import { render, staticRenderFns } from "./ScaleQuestionV2.vue?vue&type=template&id=78bf88e9&scoped=true&"
import script from "./ScaleQuestionV2.vue?vue&type=script&lang=js&"
export * from "./ScaleQuestionV2.vue?vue&type=script&lang=js&"
import style0 from "./ScaleQuestionV2.vue?vue&type=style&index=0&id=78bf88e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf88e9",
  null
  
)

export default component.exports